import { ClienteDireccionDTO, ClienteDireccionContactoDTO } from "./clientedireccion";
import { PagoRealizadoModel, pagoRealizadoInicial } from "./pagorealizado";
import { Direccion, DireccionDTO } from "./direccion";
import { ImportesGuiaDTO, TasasGuia } from "app/models/guia";
import { ImportesServicio } from "./servicio";
import { TipoAcuse } from "./guia";
import * as models from "app/models/requireme";

/**Indica la razón de porque no se puede mandar cierto servicio como FXC */
export enum ErrorFletePorCobrar {
    /**El cliente destino no acepta FXC de ningún tipo */
    DestinoNo,

    /**El cliente no acepta FXC en entregas de ZE */
    DestinoNoZE,
}
export interface ServiciosAdicionales {
    FletePorCobrar?: boolean;
    EntregaDomicilio?: boolean;
    RecoleccionDomicilio?: boolean;
    Acuse?: TipoAcuse | null;
    /**Valor declarado del paquete en caso de que se quiera asegurar el mismo */
    ValorDeclarado?: number;
    ValorFactura?: number;
    ServicioEspecial?: number;
    IdRequerimientoAcuse?: number | null;
    ImporteGastoAdministrativo?: number;
}

export interface DocumentacionPaqueteGuia {
    /**Cantidad de paquetes iguales */
    Cantidad: number;

    Peso: number;
    /**Largo en CM. Sólo aplica para los paquetes */
    Largo: number;

    /**Alto en CM. Sólo aplica para los paquetes */
    Alto: number;

    /**Ancho en CM. Sólo aplica para los paquetes */
    Ancho: number;

    /**Importe debido al envio de este servicio */
    Importes?: ImportesServicio;
    NombreCliente?: string;
    DescripcionDestino?: string;
    NombreSucursal?: string;
    IdDescripcionPaquete: number;
    NombreDescripcionPaquete?: string;
    IdContenidoPaquete: number;
    NombreContenidoPaquete?: string;
    Observaciones: string;

}

export interface DocumentacionSobreGuia {
    /**Cantidad de sobres iguales */
    Cantidad: number;

    /**Importe debido al envio de este servicio */
    Importes?: ImportesServicio;

    NombreCliente?: string;
    DescripcionDestino?: string;
    NombreSucursal?: string;
    IdContenidoSobre: number;
    NombreContenidoSobre?: string;
    Observaciones: string;
}

/**Indica un error al poner un folio de PP en la documentación */
export enum ErrorFolioPPDocumentacion {
    /**El folio no existe */
    NoExiste,
    /**Si se esta intentando documentar un paquete y no aplica para paquetes, o para sobres y no aplica para sobres */
    ServicioNoAplica,
    /**Si el folio ya fue gastado */
    Gastado,

    FacturaSinPagar,
    PaquetePPCancelado,
}

export interface ServicioDocumentacion {
    /**Id de la dirección del cliente destino */
    IdDireccionDestino: number;
    IdSucursalDestino: number;
    session: null | models.Session;
    ServiciosAdicionales: ServiciosAdicionales;
    FolioGuiaPP: string;
    Cantidad: number;
}

export interface ErrorFolioPPDocumentacionConServiciosAdicionales {
    error: ErrorFolioPPDocumentacion | null;
    servicios: models.ServiciosAdicionalesTarifaPP;
}


export interface PaqueteDocumentacion extends ServicioDocumentacion, DocumentacionPaqueteGuia {
}

export interface SobreDocumentacion extends ServicioDocumentacion, DocumentacionSobreGuia {
}

/**Parte de la documentación que se encarga de definir los servicios, las guías aún no se encuentran definidas  */
export interface DocumentacionServicios {
    IdContactoOrigen: number;
    IdSucursalOrigen: number;
    /**Teléfono del cliente */
    TelefonoCliente: string;
    Paquetes: PaqueteDocumentacion[];
    Sobres: SobreDocumentacion[];
}

export enum TipoTarifa {
    /**La tarifa se toma del cliente origen */
    Origen,
    /**La tarifa se toma del cliente destino */
    Destino,
    /**La tarifa por default */
    SinDescuento,
    /**Tariaf de paquete de guías prepagada */
    PaquetePP,
}


/**Una guia generada a partir de la documentación */
export interface DocumentacionGuia {
    IdRutaEntregaDomicilio: number | null;
    IdContactoClienteOrigen: number;
    IdDireccionClienteDestino: number;
    IdSucursalDestino: number;
    Servicios: ServiciosAdicionales;
    Paquetes: PaqueteDocumentacion[];
    Sobre: SobreDocumentacion[];
    Observaciones: string[];
    Importes: ImportesGuiaDTO;
    /**De los 3 tipos de tarifa, cual se seleccionó para esta guia, se selecciona la tarifa con el importe total mas pequeño */
    TarifaSeleccionada: TipoTarifa | null;
    TasasOrigen: TasasGuia;
    TasasDestino: TasasGuia;
    TasasSinDescuento: TasasGuia;
    /**Tasas del paquete de prepago en caso de que esta guía sea guía de prepago */
    TasasPP: TasasGuia;
    /**Distancia calculada del flete la cual se utilizó para calcular el importe del flete */
    DistanciaFlete: number;
    TiempoFlete: number;
    ImporteTotalSinDescuento: number;
    NumeroPoliza: string;
    SeguroViaje: boolean;
}

export interface DocumentacionGuias {
    Guias: DocumentacionGuia[];
    /**Importe total que tiene que pagar el origen */
    ImportesOrigen: ImportesGuiaDTO;

    /**Importes totales que se tienen que pagar en el destino */
    ImportesDestino: ImportesGuiaDTO;

    /**Id del cliente origen */
    IdClienteOrigen: number;

    NumeroPoliza: string;
    SeguroViaje: boolean;
}



export interface DocumentacionModel {
    IdDireccionDestino: number | undefined;
    IdSucursalDestino: number | undefined;
    servicios: DocumentacionServicios;
    pago: PagoRealizadoModel;
    /**Indice del tab de la UI */
    tab: number;
}

export interface NuevaDocumentacion {
    Servicios: DocumentacionServicios;
    PagoRealizado: PagoRealizadoModel;
}

export const documentacionModelInicial: DocumentacionModel = {
    IdDireccionDestino: null as any,
    IdSucursalDestino: null as any,
    servicios: {
        IdContactoOrigen: null as any,
        IdSucursalOrigen: null as any,
        TelefonoCliente: null as any,
        Paquetes: [],
        Sobres: [],
    },
    pago: pagoRealizadoInicial,
    tab: 0
}

/**Contiene el Id de la documentación y en caso de que este seste facturada tiene el id de la factura donde se encuentrén facutradas las guías que se incluyen en el */
export interface DocumentacionFactura {
    IdDocumentacion: number;
    IdFactura: number | null;
    ErrorFacturacion: string;
}



// WEBPACK FOOTER //
// ./app/models/documentacion.ts